import axios from 'axios';

export const fetcher = (url: string, params?: object) =>
	axios.get(url, { params }).then(({ data }) => data);
